__turbopack_context__.v({
  "col": "results-summary-module-scss-module__aZTeDq__col",
  "colHeading": "results-summary-module-scss-module__aZTeDq__colHeading",
  "ctaPill": "results-summary-module-scss-module__aZTeDq__ctaPill",
  "ctaRow": "results-summary-module-scss-module__aZTeDq__ctaRow",
  "docLinks": "results-summary-module-scss-module__aZTeDq__docLinks",
  "docRow": "results-summary-module-scss-module__aZTeDq__docRow",
  "eventDate": "results-summary-module-scss-module__aZTeDq__eventDate",
  "eventLinks": "results-summary-module-scss-module__aZTeDq__eventLinks",
  "eventTitle": "results-summary-module-scss-module__aZTeDq__eventTitle",
  "grid": "results-summary-module-scss-module__aZTeDq__grid",
  "linkStack": "results-summary-module-scss-module__aZTeDq__linkStack",
  "quarter": "results-summary-module-scss-module__aZTeDq__quarter",
  "quarterDetail": "results-summary-module-scss-module__aZTeDq__quarterDetail",
  "results": "results-summary-module-scss-module__aZTeDq__results",
  "rule": "results-summary-module-scss-module__aZTeDq__rule",
  "updateHighlight": "results-summary-module-scss-module__aZTeDq__updateHighlight",
});
